<div class="organization-settings-view">
  <app-organization-tab-header [organization]="organization"></app-organization-tab-header>
  <div class="organization-tab-content">
    <router-outlet></router-outlet>
  </div>
</div>
